/* */ 
"use strict";
var CssAnimationOptions = (function () {
    function CssAnimationOptions() {
        /** classes to be added to the element */
        this.classesToAdd = [];
        /** classes to be removed from the element */
        this.classesToRemove = [];
        /** classes to be added for the duration of the animation */
        this.animationClasses = [];
    }
    return CssAnimationOptions;
}());
exports.CssAnimationOptions = CssAnimationOptions;
//# sourceMappingURL=css_animation_options.js.map